type StoreVisibleProduct = {
  isAvailable?: boolean | null;
  status?: string | null;
};

export const isStoreVisibleProduct = (product: StoreVisibleProduct) =>
  product.isAvailable !== false && product.status !== 'inactive';
